import { action, computed, observable } from 'mobx';
import { auth as authService } from '@triplabo/web/services';
import { UserType } from '@linktivity/triplabo-taxi';
import { getCurrentDevice } from '@triplabo/web/utils';
import type { User } from '@linktivity/link-utils';
export const ACCESS_TOKEN = 'accessToken';
export const REFRESH_TOKEN = 'refreshToken';
export const USER_TYPE = 'userType';
export const SIGNATURE = 'signature';
export const SHARE_DIALOG_SHOWN = 'shareDialogShown';
export interface UserInfo {
  userType?: string;
}
export class AuthStore {
  @observable accessor accessToken: string | null =
    localStorage.getItem(ACCESS_TOKEN);
  @observable accessor refreshToken: string | null =
    localStorage.getItem(REFRESH_TOKEN);
  @observable accessor userType: string | null = getCurrentDevice();
  @observable accessor signature: string | null =
    localStorage.getItem(SIGNATURE);
  @observable accessor user: User | null = null;

  @action
  setAccessToken(accessToken?: string) {
    if (accessToken) {
      this.accessToken = accessToken;
      localStorage.setItem(ACCESS_TOKEN, accessToken);

      // 如果设置了ACCESS_TOKEN，则删除signature（与signature只能二选一）
      if (this.signature) {
        localStorage.removeItem(SIGNATURE);
      }
    }
  }

  @action
  setSignature(signature?: string) {
    if (signature) {
      this.signature = signature;
      localStorage.setItem(SIGNATURE, signature);

      // 如果设置了signature，则删除accessToken （与ACCESS_TOKEN只能二选一）
      if (this.signature) {
        localStorage.removeItem(ACCESS_TOKEN);
      }
    }
  }

  @action
  setRefreshToken(refreshToken?: string) {
    if (refreshToken) {
      this.refreshToken = refreshToken;
      localStorage.setItem(REFRESH_TOKEN, refreshToken);
    }
  }

  @action
  clearTokens() {
    this.accessToken = null;
    this.refreshToken = null;
    this.signature = null;
    localStorage.removeItem(ACCESS_TOKEN);
    localStorage.removeItem(REFRESH_TOKEN);
    localStorage.removeItem(SIGNATURE);
  }

  @action
  async getRefreshedToken() {
    const response = await authService.refresh({
      body: {
        refreshToken: this.refreshToken || ''
      }
    });
    if (response) {
      this.setAccessToken(response.accessToken);
      this.setRefreshToken(response.refreshToken);
      return response.accessToken;
    }
  }

  @action
  setWebUser = (user: User) => {
    this.user = user;
  };

  @action
  setWebToken = async () => {
    const token = await this.user?.getIdToken();
    this.setAccessToken(token || '');
  };

  @computed
  get loggedIn(): boolean {
    return !!this.accessToken;
  }

  @computed
  get isHardware(): boolean {
    return this.userType === UserType.Hardware;
  }

  @computed
  get isWeb(): boolean {
    return this.userType === UserType.Web;
  }

  @computed
  get isWechat(): boolean {
    return this.userType === UserType.Wechat;
  }
}

const auth = new AuthStore();

export default auth;
